import { render, staticRenderFns } from "./StylistOrdersTable.vue?vue&type=template&id=075bf05c"
import script from "./StylistOrdersTable.vue?vue&type=script&lang=js"
export * from "./StylistOrdersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports